export enum Modules
{
    Roles = 1,
    Users = 2,
    Tenants = 3,
    TenantSettings = 4,
    Files = 5,
    Contents = 10,
    FAQs = 11,
    AutoAnswerTypes = 12,
    ClassifierGroups = 13,
    ComplaintClassifications = 14,
    Forms = 15,
    FormSubTypes = 16,
    Complaints = 17,
    Alerts = 18,
    Case=19,
    UserGroups = 20,
    Workflows = 21,
    FollowUpTasks = 22,
    Labels = 23,
    LabelCustomizations = 24,
    FlatReport=25,
    PPFolderAndFiles=26,
    Risks=27,
    Approvals = 28,
    Audit = 29,
    AlertCriticality = 30,
    RejectedReason = 31

}